import PropTypes from 'prop-types';
import TourItineraryContent from '../../../../TravelOption/TourInformation/TourItinerary/TourItineraryContent';

const TourCompareTable = ({ tourTravelOptions, doShowViewButtonColumn, doShowPrice }) =>
  tourTravelOptions &&
  tourTravelOptions.map((travelOption, index) => (
    <div key={travelOption?.itinerary?.uniqueKey} style={{ marginTop: index > 0 ? 24 : 0 }}>
      <TourItineraryContent
        itinerary={travelOption.itinerary}
        doShowPrice={doShowPrice}
        doShowAvailabilityButton={false}
        doShowDetailsButton={doShowViewButtonColumn}
      />
    </div>
  ));

TourCompareTable.propTypes = {
  tourTravelOptions: PropTypes.arrayOf(PropTypes.objectOf).isRequired,
  doShowViewButtonColumn: PropTypes.bool,
  doShowPrice: PropTypes.bool,
};

TourCompareTable.defaultProps = {
  doShowViewButtonColumn: true,
  doShowPrice: true,
};

export default TourCompareTable;
